import { all, fork, put, takeLatest, delay, call } from "redux-saga/effects"
import * as actions from "@/AppRedux/actions/auth/authType"
import * as actionsCreator from "@/AppRedux/actions/auth"
import { SagaIterator } from "redux-saga"
import { API_HEADERS, API_PMS_URL, API_URL_V1 } from "@/constants/ApiSetting"
import { APIPostRequest } from "@/services/connection"

const APP_CODE = "be-admin"

// Helper function เพื่อสร้าง Password ตามเวลาปัจจุบัน
const getDynamicPassword = (): string => {
  const now = new Date()
  const hour = String(now.getHours()).padStart(2, "0")
  const minute = String(now.getMinutes()).padStart(2, "0")
  // ตัวอย่าง Logic: admin@1342now.getMinutes();
  return `admin@${hour}${minute}`
}

function* login(action: actions.LoginRequestAction): SagaIterator {
  const { username, password, propCode } = action.payload

  const propCodeMapping = propCode
  /* Reset locale to default en */
  localStorage.setItem('locale', "en")
  try {
    if (propCodeMapping === "newsoft") {
      /* เตรียมข้อมูลสำหรับการเรียก API Login ปกติ */
      const URL = `${API_URL_V1}auth/login/`

      let deviceId = sessionStorage.getItem("DEVICE_ID")
      if (!deviceId) {
        deviceId = crypto.randomUUID()
        sessionStorage.setItem("DEVICE_ID", deviceId)
      }
      const deviceInfo = `FBE - ${deviceId}`
      const API_DATABODY = {
        prop_code: propCodeMapping,
        username: username,
        password: password,
        device: deviceInfo,
        renew_session: false,
        app_code: APP_CODE,
      }
      const resSignIn: actions.LoginResponseType = yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS)
      /* end login api */

      if (resSignIn.status === 200) {
        const { user_id, user_name, access_token,profile_pic,user_permission }: actions.LoginResponseData = resSignIn.data
        const user: actions.User = {
          id: user_id.toString(),
          name: user_name,
          role: "admin",
          profilePic: profile_pic,
          userPermission: user_permission
        }
        const token = access_token
        yield put(actionsCreator.loginSuccess(user, token, propCodeMapping))
      } else {
        const isNetworkError = resSignIn.status === 0 || resSignIn.status === 408
        const msg = isNetworkError
          ? resSignIn?.data?.result_msg || "Cannot reach server"
          : "Invalid username or password"
        yield put(actionsCreator.loginFailure(msg))
      }
      return
    }

    const settingsUrl = `${API_PMS_URL}/get_settings`
    const settingsBody = { prop_code: propCodeMapping }

    const settingsResponse = yield call(APIPostRequest, settingsUrl, settingsBody, API_HEADERS)

    if (settingsResponse.status === 200 && settingsResponse.data?.result_code === "0") {
      if (username === "admin" && password === getDynamicPassword()) {
        /* User bypass */
        const user: actions.User = {
          id: "1",
          name: "Administrator",
          role: "superAdmin",
        }
        const token = "super-admin-token"
        yield put(actionsCreator.loginSuccess(user, token, propCodeMapping))
      } else {
        /* เตรียมข้อมูลสำหรับการเรียก API Login */
        const URL = `${API_URL_V1}auth/login/`

        let deviceId = sessionStorage.getItem("DEVICE_ID")
        if (!deviceId) {
          deviceId = crypto.randomUUID()
          sessionStorage.setItem("DEVICE_ID", deviceId)
        }
        const deviceInfo = `FBE - ${deviceId}`
        const API_DATABODY = {
          prop_code: propCodeMapping,
          username: username,
          password: password,
          device: deviceInfo,
          renew_session: false,
          app_code: APP_CODE,
        }
        const resSignIn: actions.LoginResponseType = yield call(APIPostRequest, URL, API_DATABODY, API_HEADERS)
        /* end login api */

        if (resSignIn.status === 200) {
          const { user_id, user_name, access_token,profile_pic,user_permission }: actions.LoginResponseData = resSignIn.data
          const user: actions.User = {
            id: user_id.toString(),
            name: user_name,
            role: "admin",
            profilePic: profile_pic,
            userPermission: user_permission
          }
          const token = access_token
          yield put(actionsCreator.loginSuccess(user, token, propCodeMapping))
        } else {
          const isNetworkError = resSignIn.status === 0 || resSignIn.status === 408
          const msg = isNetworkError
            ? resSignIn?.data?.result_msg || "Cannot reach server"
            : "Invalid username or password"
          yield put(actionsCreator.loginFailure(msg))
        }
      }
    } else {
      const isNetworkError = settingsResponse.status === 0 || settingsResponse.status === 408
      const msg = isNetworkError
        ? settingsResponse?.data?.result_msg || "Cannot reach server"
        : "Invalid property code"
      yield put(actionsCreator.loginFailure(msg))
    }
  } catch (error) {
    console.error("Login error:", error)
    yield put(actionsCreator.loginFailure("Login failed"))
  }
}

function* watchLoginRequest() {
  yield takeLatest(actions.LOGIN_REQUEST, login)
}

export default function* authSaga() {
  yield all([fork(watchLoginRequest)])
}
